export enum LocationParams {
  LocationId = 'locationId',
  ParentLocationId = 'parentLocationId',
  LocationFilter = 'locationFilter',
}

export enum LocationAdminPaths {
  Courtrooms = 'courtrooms',
  Courthouses = 'courthouses',
}

export enum LocationAdminData {
  Type = 'type',
  Action = 'action',
}

export enum CourtroomTab {
  GoldReporters = 'reporters',
  ChannelLabels = 'channel-labels',
  SpeechToText = 'speech-to-text',
  Departments = 'departments',
  Scheduling = 'scheduling',
  DigitalJustice = 'digital-justice',
}
